module.exports = __webpack_public_path__ + "static/media/covid-vaccine-banner.abf030a3.png";